<template>
  <div>
    <slot name="trigger" v-bind:open="open"></slot>

    <Modal size="md" :show="show" @closeModal="close">
      <div class="border-b">
        <h3 class="text-lg leading-6 font-medium text-gray-900 mb-2">
          Filters
        </h3>
      </div>
      <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <text-input label="Search" v-model="value.search" :placeholder="currentPlaceholder"></text-input>
          <span class="text-xs text-gray-500">Search for orders by using the flag: (orders:xxxxxx,xxxxxx)</span>
        </div>
        <div v-if="teams && teams.length > 0">
          <select-input label="Team" v-model="value.team">
            <option :value="null">All</option>
            <option v-for="team in teams" :value="team.id">{{ team.name }}</option>
          </select-input>
        </div>
        <div>
          <select-input label="Warehouse" v-model="value.warehouse">
            <option :value="null">All</option>
            <option v-for="warehouse in warehouses" :value="warehouse.id">{{ warehouse.name }}</option>
          </select-input>
        </div>
        <div>
          <select-input label="Location" v-model="value.location">
            <option :value="null">All</option>
            <option v-for="(label, value) in locations" :value="value">{{ label }}</option>
          </select-input>
        </div>
        <div v-if="filters.location === 'island'">
          <select-input label="Vessel" v-model="value.boat" >
            <option :value="null">All</option>
            <option v-for="vessel in vessels" :value="vessel.id">{{ vessel.name }}</option>
          </select-input>
        </div>
        <div>
          <date-input label="Date" v-model="value.delivery_date"></date-input>
        </div>
        <div v-if="!type">
          <select-input label="Delivery Method" v-model="value.method">
            <option value="delivery">To be Delivered</option>
            <option value="collection">Collection by Customer</option>
          </select-input>
        </div>
        <div>
          <select-input label="Status" v-model="value.status">
            <option value="pending">Pending</option>
            <option value="in-progress">In Progress</option>
            <option value="completed">Completed</option>
          </select-input>
        </div>
      </div>
      <div class="mt-6 flex justify-end w-full gap-3">
        <slot name="footer">
          <button @click="close" class="btn-primary bg-gray-400 py-3">Cancel</button>
          <button @click="reset" class="btn-primary bg-gray-400 py-3">Reset</button>
          <button @click="apply" class="btn-primary py-3">Apply</button>
        </slot>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/Shared/Modal.vue";
import SelectInput from "@/Shared/SelectInput.vue";
import TextInput from "@/Shared/TextInput.vue";
import DateInput from "@/Shared/DateInput.vue";
import placeholderCyclerMixin from "@/Mixins/placeholderCyclerMixin";

export default {
  name: 'NoteFilterModal',
  mixins: [placeholderCyclerMixin],
  components: {DateInput, TextInput, SelectInput, Modal},

  props: {
    value: Object,
    teams: Array,
    warehouses: Array,
    locations: Object,
    vessels: Array,
    filters: Object,
    type: null,
  },

  data() {
    return {
      show: false,
    }
  },

  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },

    reset() {
      this.$emit('reset')
      this.close()
    },

    apply() {
      this.value.warehouse = 'all'
      this.$emit('apply')
      this.close()
    }
  }
}
</script>
